module.exports = __webpack_public_path__ + "img/bg4.0e0109ae.jpg";